import React from 'react';

import brokenBob from 'imgs/broken-image.svg';

import refreshIcon from './refresh-icon.svg';

import './ErrorBoundaryView.css';

const ErrorBoundaryBackground = ({ children }: { children: React.ReactNode }) => {
  return <div className="ErrorBoundaryView">{children}</div>;
};

const getErrorMessage = (error: Error) => {
  // Ref: https://github.com/vitejs/vite/issues/11804
  const chunkLoadErrorMessages = [
    'Failed to fetch dynamically imported module', // Chrome, Opera, Edge
    'Importing a module script failed', // Safari
    'error loading dynamically imported module' // Firefox
  ];
  const isChunkLoadError = chunkLoadErrorMessages.some(message =>
    error.message.toLowerCase().includes(message.toLowerCase())
  );
  const title = isChunkLoadError ? 'Good news, a new app version is available!' : "Oops, there's been a problem";
  const message = "Reload and you'll be right back where you were.";
  const icon = isChunkLoadError ? refreshIcon : brokenBob;

  return { title, message, icon };
};

interface ErrorBoundaryModalProps {
  title: string;
  message: string;
  icon: string;
}
const ErrorBoundaryModal = ({ title, message, icon }: ErrorBoundaryModalProps) => {
  return (
    <div className="ErrorBoundaryView_modal">
      <img className="ErrorBoundaryView_image" alt="" src={icon} />
      <h2 className="ErrorBoundaryView_title">{title}</h2>
      <div className="ErrorBoundaryView_body">
        <p className="">{message}</p>
        <p className="">To reload:</p>
        <ul className="">
          <li>Press CTRL + R (Windows)</li>
          <li>Press CMD + R (Mac)</li>
          <li>Click reload from the top menu</li>
        </ul>
      </div>
    </div>
  );
};

interface ErrorBoundaryViewProps {
  children: React.ReactNode;
}

interface ErrorBoundaryViewState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundaryView extends React.Component<ErrorBoundaryViewProps, ErrorBoundaryViewState> {
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  constructor(props: ErrorBoundaryViewProps) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { error, hasError } = this.state;

    if (hasError && error) {
      return (
        <ErrorBoundaryBackground>
          <ErrorBoundaryModal {...getErrorMessage(error)} />
        </ErrorBoundaryBackground>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryView;
